import AsoHeader from "../../../components/Aso/Header";
import AsoFuncaoEmpresa from "../../../components/Aso/Register/AsoFuncaoEmpresa";

const AsoRegistroFuncaoEmpresa = () => {
    return (
        <>
            <AsoHeader />
            <AsoFuncaoEmpresa />
        </>
    );
}

export default AsoRegistroFuncaoEmpresa;